import React, { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { CardSkeleton } from "@/components/Skeletons";
import { motion } from "framer-motion";

export default function Wallet() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/wallet").then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <CardSkeleton />;

  const net = data?.net_balance ?? 0;
  const positive = net >= 0;

  return (
    <div className="space-y-6 lg:max-w-3xl">
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400 font-semibold">Overview</div>
        <h1 className="heading text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 mt-1">My Wallet</h1>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        className={`rounded-3xl p-7 border grain relative overflow-hidden ${positive ? "bg-emerald-50 border-emerald-200" : "bg-rose-50 border-rose-200"}`}
      >
        <div className="text-xs uppercase tracking-widest font-semibold text-slate-500">Net wallet balance</div>
        <div className={`amount text-5xl font-bold mt-2 ${positive ? "text-emerald-700" : "text-rose-700"}`} data-testid="wallet-net-balance">
          {inr(net)}
        </div>
        <p className="mt-2 text-sm text-slate-600">
          {positive ? "Others owe you money." : "You owe money in total."}
        </p>
      </motion.div>

      <section>
        <h2 className="heading text-lg font-semibold text-slate-900 mb-3">By group</h2>
        <div className="space-y-3">
          {data?.by_group.map(({ group, balance }) => (
            <button
              key={group.id}
              onClick={() => navigate(`/groups/${group.id}`)}
              className="w-full text-left flex items-center gap-3 p-4 rounded-2xl bg-white border border-slate-200 hover:border-slate-300"
              data-testid={`wallet-group-${group.id}`}
            >
              <div className="w-11 h-11 rounded-2xl bg-slate-900 text-white grid place-items-center heading font-semibold">
                {group.name[0]}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-slate-900">{group.name}</div>
                <div className="text-xs text-slate-500">{group.member_ids?.length || 0} members</div>
              </div>
              <div className={`amount font-bold ${balance >= 0 ? "text-emerald-600" : "text-rose-600"}`}>
                {inr(balance)}
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
